export const GROUPS = {
  owner: "owner",
  admin: "admin",
  buyer: "buyer",
  supervisor: "supervisor",
  requester: "requester",
} as const;

export type GroupKey = (typeof GROUPS)[keyof typeof GROUPS];

/**
 * Group rank order (lower index = higher rank).
 * Used to determine avatar color by highest-ranking group.
 */
export const GROUP_RANK_ORDER: GroupKey[] = [
  GROUPS.owner,
  GROUPS.admin,
  GROUPS.supervisor,
  GROUPS.buyer,
  GROUPS.requester,
];

/**
 * Avatar background colors by group.
 * Tailwind classes for bg color.
 */
export const GROUP_AVATAR_COLORS: Record<GroupKey, string> = {
  [GROUPS.owner]: "bg-amber-600 text-white",
  [GROUPS.admin]: "bg-rose-600 text-white",
  [GROUPS.supervisor]: "bg-violet-600 text-white",
  [GROUPS.buyer]: "bg-sky-600 text-white",
  [GROUPS.requester]: "bg-emerald-600 text-white",
};

/**
 * Human-readable labels for each group.
 */
export const GROUP_LABELS: Record<GroupKey, string> = {
  [GROUPS.owner]: "Propietario",
  [GROUPS.admin]: "Administrador",
  [GROUPS.supervisor]: "Supervisor",
  [GROUPS.buyer]: "Comprador",
  [GROUPS.requester]: "Solicitante",
};

/**
 * Returns the avatar color class for the highest-ranking group.
 */
export function getAvatarColorByGroups(groups: GroupKey[]): string {
  const DEFAULT_COLOR = "bg-neutral-200 text-black dark:bg-neutral-700 dark:text-white";

  if (!groups || groups.length === 0) return DEFAULT_COLOR;

  for (const rankedGroup of GROUP_RANK_ORDER) {
    if (groups.includes(rankedGroup)) {
      return GROUP_AVATAR_COLORS[rankedGroup];
    }
  }

  return DEFAULT_COLOR;
}

